import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import html2canvas from "html2canvas";
import { FixtureResult, FixtureOpponent } from "../types/team";
import MatchRow from "../components/MatchRow";
import TeamLogo from "../components/TeamLogo";

export default function FixturePage() {
  const location = useLocation();
  const navigate = useNavigate();

  const result = location.state as FixtureResult | undefined;
  const [visibleFixture, setVisibleFixture] = useState<FixtureOpponent[]>([]);
  const fixtureRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!result) return;
    let index = 0;
    const interval = setInterval(() => {
      const nextOpponent = result.fixture[index];
      if (nextOpponent) {
        setVisibleFixture((prev) => [...prev, nextOpponent]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [result]);

  if (!result) {
    return (
      <div className="p-6 text-center">
        <h2 className="text-2xl">Hiç takım seçilmedi!</h2>
        <button
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
          onClick={() => navigate("/")}
        >
          Geri Dön
        </button>
      </div>
    );
  }

  const { team } = result;

  return (
    <div
      ref={fixtureRef}
      className="p-6 max-w-3xl mx-auto bg-white bg-opacity-90 rounded-lg shadow-xl backdrop-blur-sm text-gray-900"
    >
      <div className="flex items-center gap-4 mb-6">
        <TeamLogo logo={team.logo} name={team.name} className="w-14 h-14" />
        <h1 className="text-2xl font-extrabold text-gray-800">
          {team.name} <span className="font-medium text-gray-600">({team.country})</span>
        </h1>
      </div>

      <p className="text-lg font-semibold text-green-600">📌 Lig aşamasında!</p>

      <h3 className="text-xl mt-6 mb-4 font-bold text-gray-800">🎯 Fikstür (MD1–MD8):</h3>
      <ul className="space-y-3">
        {visibleFixture
          .slice()
          .sort((a, b) => a.matchday - b.matchday)
          .map((opponent) => (
            <motion.li
              key={opponent.name}
              className="flex items-center gap-3"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
            >
              <span className="font-bold text-gray-500 w-12 shrink-0">MD{opponent.matchday}</span>
              <MatchRow team={team} opponent={opponent} />
            </motion.li>
          ))}
      </ul>

      <div className="text-center">
        <button
          className="mt-6 px-5 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg transition"
          onClick={() => navigate("/")}
        >
          🔁 Yeni Simülasyon Başlat
        </button>

        <button
          className="mt-4 ml-4 px-5 py-2 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-lg transition"
          onClick={async () => {
            if (fixtureRef.current) {
              const canvas = await html2canvas(fixtureRef.current);
              const dataUrl = canvas.toDataURL("image/png");
              const link = document.createElement("a");
              link.href = dataUrl;
              link.download = "fikstur.png";
              link.click();
            }
          }}
        >
          📸 Fikstürü Görsel Olarak İndir
        </button>
      </div>
    </div>
  );
}
